module.exports = __webpack_public_path__ + "static/media/view4.c4a6cd40.jpg";